import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import logoMain from '../../assets/images/users/mdLogo.png';

export default function LogoMain({ sx }) {
  const theme = useTheme();
  const { currentCompany } = useSelector((state) => state.company);

  const API_BASE = import.meta.env.VITE_APP_API_URL || '';
  const BASE_URL = API_BASE.replace(/\/api\/?$/, ''); // "/api" hata kar sirf domain rakho

  const logoSrc = currentCompany?.logo_url ? `${BASE_URL}${currentCompany.logo_url}` : logoMain;
  const companyName = currentCompany?.company_name || '';

  // Auto-shrink font size for long company names so it never breaks the layout
  const fontSize = companyName.length > 18 ? '0.8rem' : companyName.length > 12 ? '0.92rem' : '1.05rem';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.1, minWidth: 0, maxWidth: '100%', ...sx }}>
      <Box
        sx={{
          flexShrink: 0,
          width: 44,
          height: 44,
          borderRadius: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.03)',
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
        }}
      >
        <img
          src={logoSrc}
          alt="ERP POS Portal"
          onError={(e) => { e.target.onerror = null; e.target.src = logoMain; }}
          style={{
            maxHeight: '36px',
            maxWidth: '36px',
            width: 'auto',
            height: 'auto',
            objectFit: 'contain',
            display: 'block'
          }}
        />
      </Box>
      {companyName && (
        <Tooltip title={companyName} enterDelay={500} disableInteractive>
          <Box sx={{ minWidth: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Typography
              noWrap
              sx={{
                fontSize,
                fontWeight: 800,
                letterSpacing: '0.2px',
                lineHeight: 1.15,
                fontFamily: '"Sofia Sans", sans-serif',
                background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark || theme.palette.primary.main})`,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}
            >
              {companyName}
            </Typography>
            <Typography
              noWrap
              sx={{
                fontSize: '0.65rem',
                fontWeight: 500,
                letterSpacing: '0.6px',
                color: 'text.disabled',
                textTransform: 'uppercase',
                mt: '1px'
              }}
            >
              ERP &amp; POS
            </Typography>
          </Box>
        </Tooltip>
      )}
    </Box>
  );
}